// extracted by mini-css-extract-plugin
export default {"container":"styles_container__m+g17","projectLogoContainer":"styles_projectLogoContainer__cLIZm","programLogoContainer":"styles_programLogoContainer__SinWD"};